var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09244BFF",
    d: "M4 12a8 8 0 0 1 8-8c5.367 0 8.445 4.445 8.006 8.39-.12 1.086-.438 1.723-.72 2.095-.281.373-.571.54-.733.62-.753.377-1.133.212-1.283.093-.19-.15-.372-.503-.284-1.034l.006-.032.503-5.032a1 1 0 0 0-1.867-.59A5.025 5.025 0 0 0 12.03 7C9.279 7 7 9.229 7 12c0 2.774 2.288 5 5.038 5 1.212 0 2.35-.436 3.237-1.176.175.36.425.682.753.942.917.726 2.172.752 3.42.128.337-.168.91-.51 1.434-1.203.524-.694.956-1.682 1.112-3.08C22.556 7.554 18.633 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10a9.963 9.963 0 0 0 4.445-1.04 1 1 0 0 0-.89-1.791A8 8 0 0 1 4 12m5 0c0-1.647 1.364-3 3.03-3 1.92 0 3.364 1.767 2.974 3.62-.291 1.378-1.539 2.38-2.966 2.38C10.368 15 9 13.645 9 12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtLine);
export default __webpack_public_path__ + "static/media/at_line.e7a4506be538e538f08e1b88e507211f.svg";
export { ForwardRef as ReactComponent };